'use strict';

import { observable, action, configure, makeObservable } from "mobx";
configure({enforceActions: 'always'});

import planItemStore from "./PlanItemStore";
import events from '@uw-it-sis/lib-react/lib/Events';
import PlanEvents from './PlanEvents';
import {isEmpty} from "@uw-it-sis/lib-react/lib/Utils";
import {States} from '@uw-it-sis/lib-react/lib/AppConstants';

class AddEditNoteFormStore {
    state = States.initial;

    data = {
        // For tracking if the add/edit note action was successful
        successful: false,
        // For error messaging
        updateFailedMessage: "",
        // default form data
        formData: {
            planItemId: "",
            courseCode: "",
            termId: "",
            note: "",
            credit: ""
        }
    };

    constructor() {
        makeObservable(this, {
            state: observable,
            data: observable,
            mount: action,
            updateFormData: action,
            updateNote: action,
            finishPlanItemUpdate: action,
            errorPlanItemUpdate: action
        });
    }

    /**
     * initialize ( or reset ) internal state
     */
    mount(courseCode, planItemId, termId, note, credit) {
        this.data.successful = false;
        this.data.updateFailedMessage = "";
        this.data.formData = {
            planItemId: planItemId,
            courseCode: courseCode,
            termId: termId,
            note: note,
            credit: credit
        };

        events.listen(PlanEvents.planItemUpdated, (eventObject) => {
            if (eventObject.planItemId === this.data.formData.planItemId) {
                this.finishPlanItemUpdate();
            }
        });

        events.listen(PlanEvents.planItemError, (eventObject) => {
            if (eventObject.planItemId === this.data.formData.planItemId) {
                this.errorPlanItemUpdate(eventObject.errMessage);
            }
        });

        this.state = States.done;
    }

    unmount() {
        events.remove(PlanEvents.planItemUpdated, (eventObject) => {
            if (eventObject.planItemId === this.data.formData.planItemId) {
                this.finishPlanItemUpdate();
            }
        });

        events.remove(PlanEvents.planItemError, (eventObject) => {
            if (eventObject.planItemId === this.data.formData.planItemId) {
                this.errorPlanItemUpdate(eventObject.errMessage);
            }
        });
    }

    updateFormData(property, newValue) {
        if ( ! isEmpty(this.data) ) {
            this.data.formData[property] = newValue;
        }
    }

    getFormData() {
        return this.data.formData;
    }

    updateNote() {
        this.state = States.pending;
        this.data.updateFailedMessage = undefined;

        let formdata = this.getFormData();

        planItemStore.update(formdata.planItemId, formdata.courseCode, formdata.termId,
            formdata.note, formdata.credit);
    }

    finishPlanItemUpdate() {
        this.data.successful = true;
        this.state = States.done;
    }

    isSuccessful() {
        return this.data.successful;
    }

    errorPlanItemUpdate(errorMessage) {
        this.data.updateFailedMessage = errorMessage;
        this.state = States.error;
    }

    getUpdateFailedMessage() {
        return this.data.updateFailedMessage;
    }
}

export default new AddEditNoteFormStore();